Apt.fn.make('blocks', {
	/**
	 * Initialize module
	 */
	init: function() {
		CF.util.idle(function() {
			this.$private.initPhotos();
		});
	},

	/**
	 * Initialize block photos navigation
	 */
	initPhotos: function() {
		var $photos = $$('blockPhoto'),
			$nav = $$('blockPhotosNav'),
			visibleClass = '-is-visible';

		$nav.on('click.blocks', function() {
			var dir = $(this).data('dir'),
				$visible = $photos.filter('.' + visibleClass),
				$first = $photos.first(),
				$last = $photos.last();

			$visible.removeClass(visibleClass);

			if (dir === 'next') {
				$photos.eq(
					$visible.is($last) ? 0 : $visible.index() + 1
				).addClass(visibleClass);
			}

			if (dir === 'prev') {
				$photos.eq(
					$visible.is($first) ? $last.index() : $visible.index() - 1
				).addClass(visibleClass);
			}
		});
	},

	/**
	 * Unload module
	 */
	unload: function() {
		$.events.reset('blocks');
	}
});